import useQuasar from 'quasar/src/composables/use-quasar/use-quasar.js';

export function notifyApp() {
    const $q = useQuasar()

    const Message = (type, message) => {
        $q.notify({
            progress: true,
            type: type,
            multiLine: true,
            message: message
        })
    }
    return {
        Message
    }
}